"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QUERY_KEY_PREFERENCE = exports.usePreference = exports.useUserPreferences = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const react_query_1 = require("react-query");
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const ObjectivesClient_1 = require("src/client/ObjectivesClient");
const QUERY_KEY_PREFERENCE = 'preference-filter';
exports.QUERY_KEY_PREFERENCE = QUERY_KEY_PREFERENCE;
const usePreference = ({ module, page, section, cycleId }) => {
    const queryClient = (0, react_query_1.useQueryClient)();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const queryData = queryClient.getQueryData(QUERY_KEY_PREFERENCE);
    const data = queryData?.data || [];
    const isSuccess = queryData?.isSuccess || false;
    const getCondition = (data) => {
        return (data.module == module &&
            data.page == page &&
            data.section == section &&
            (cycleId ? data?.cycle?.id == cycleId : true));
    };
    const dataResult = data.find((data) => getCondition(data)) || {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const saveFilter = async (filter) => {
        if ((0, isEmpty_1.default)(filter))
            return;
        const params = {
            ...filter,
            module,
            page,
            section
        };
        const { data, isSuccess } = await (module === 'formal_review'
            ? (0, ObjectivesClient_1.updateFormalReviewPreferencesFilter)(params)
            : (0, ObjectivesClient_1.updatePreferencesFilter)(params));
        if (!isSuccess && !data)
            return;
        const { data: draft } = queryClient.getQueryData(QUERY_KEY_PREFERENCE);
        const draftData = draft?.slice() || [];
        const edittedIndex = draftData.findIndex((data) => getCondition(data));
        if (edittedIndex > -1) {
            draftData[edittedIndex] = data;
        }
        else {
            draftData.push(data);
        }
        queryClient.setQueryData(QUERY_KEY_PREFERENCE, (prevData) => ({
            ...prevData,
            data: draftData
        }));
    };
    return {
        data: dataResult ? { ...dataResult, data: dataResult?.data || [] } : null,
        isLoaded: isSuccess,
        saveFilter
    };
};
exports.usePreference = usePreference;
const useUserPreferences = (queryKey, queryConfig) => {
    const queryFn = () => {
        return (0, ObjectivesClient_1.getPreferencesFilter)();
    };
    return (0, react_query_1.useQuery)(queryKey, queryFn, queryConfig);
};
exports.useUserPreferences = useUserPreferences;
